var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotification = function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5A239",
    d: "M13.18 7.764c-.487-.57-.709-1.062-.709-1.9V5.58c0-1.09-.25-1.794-.797-2.497-.841-1.092-2.258-1.75-3.645-1.75H7.97c-1.357 0-2.73.628-3.585 1.676-.576.717-.856 1.45-.856 2.571v.285c0 .837-.207 1.33-.709 1.899-.369.419-.487.957-.487 1.54 0 .583.192 1.136.576 1.585.502.539 1.21.882 1.933.942 1.048.12 2.095.165 3.158.165 1.062 0 2.11-.076 3.158-.165a3.021 3.021 0 0 0 1.933-.942 2.41 2.41 0 0 0 .576-1.585c0-.583-.118-1.121-.487-1.54Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5A239",
    d: "M9.339 12.819c-.333-.071-2.364-.071-2.697 0-.285.066-.593.219-.593.555.016.32.204.602.463.782.336.262.73.429 1.143.489.22.03.444.029.672 0 .412-.06.806-.227 1.142-.489.259-.18.446-.462.463-.782 0-.336-.308-.49-.593-.555Z",
    opacity: 0.4
  })));
};
export default SvgNotification;